<template>
    <div>
        <table>
            <tr>
                <td>倍率・ヒダスタイル</td>
                <td>
                    <b-form-select v-model="hida_selected"
                                   :options="options"></b-form-select>
                </td>
            </tr>
            <tr v-bind:class="{hidden_select:suso_options.length===1}"
                v-if="
            $store.state.xlsx_data.item_data['SH'+$store.state.step1_data.item_number]['ヨコ使い'] === '○' &&
            $store.state.xlsx_data.item_data['SH'+$store.state.step1_data.item_number]['絵羽'] !== '絵羽'
            ">
                <td>裾形状を選ぶ</td>
                <td>
                    <b-form-select v-model="suso_selected"
                                   :options="suso_options"></b-form-select>
                </td>
            </tr>
            <tr v-if="$store.state.xlsx_data.item_data['SH'+$store.state.step1_data.item_number]['絵羽'] === '絵羽'">
                <td>裾形状を選ぶ</td>
                <td>
                    <b-form-select v-model="suso_selected"
                                   :options="eba_options"></b-form-select>
                </td>
            </tr>
            <tr v-if="
            group2==='トリムスタイル' ||
            style_selected2_name === 'スカラップトリム センターウェーブ' ||
            style_selected2_name === 'スカラップトリム ウェーブ' ||
            style_selected2_name === 'スカラップトリム アーチ' ||
            style_selected2_name === 'スカラップトリム M'
            ">
                <td>トリム品番を選ぶ</td>
                <td>
                    <b-form-select v-model="trim_selected"
                                   :options="$store.state.xlsx_select_data.select_data['カーテン'][$store.state.step2_data.style_selected2_name]['フリンジ品番・トリム品番を選ぶ'].option"></b-form-select>
                </td>
            </tr>
            <tr>
                <td>開閉方法</td>
                <td>
                    <b-form-select v-model="open_method_selected"
                                   :options="open_options"></b-form-select>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "curtain_lace",
        created : function(){
            const style_name = (this.$store.state.step2_data.style_selected2_name !=='') ? this.$store.state.step2_data.style_selected2_name : this.$store.state.step2_data.style_selected1_name
            if(this.hida_selected === ''){
                this.hida_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][style_name]['ヒダ倍率・ヒダスタイルを選ぶ'].option[0].value
            }
            if(this.suso_selected === ''){
                if(this.$store.state.xlsx_data.item_data['SH'+this.$store.state.step1_data.item_number]['絵羽'] === '絵羽'){
                    this.suso_selected = '裾刺繍'
                }else{
                    this.suso_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][style_name]['裾形状を選ぶ↓ヨコ使いレース生地のみ'].option[0].value
                }
            }
            if(this.open_method_selected === ''){
                this.open_method_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][style_name]['開閉方法を選ぶ'].option[0].value
            }
            if(
                this.trim_selected === '' && this.$store.state.step2_data.style_selected2_id &&
                this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2==='トリムスタイル' ||
                this.$store.state.step2_data.style_selected2_name === 'スカラップトリム センターウェーブ' ||
                this.$store.state.step2_data.style_selected2_name === 'スカラップトリム ウェーブ' ||
                this.$store.state.step2_data.style_selected2_name === 'スカラップトリム アーチ' ||
                this.$store.state.step2_data.style_selected2_name === 'スカラップトリム M'
            ){
                this.trim_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][style_name]['フリンジ品番・トリム品番を選ぶ'].option[0].value
            }
        },
        watch : {
            style_selected1_name : function(value){
                const style_name = (this.$store.state.step2_data.style_selected2_name !=='') ? this.$store.state.step2_data.style_selected2_name : this.$store.state.step2_data.style_selected1_name
                if(this.hida_selected === ''){
                    this.hida_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][style_name]['ヒダ倍率・ヒダスタイルを選ぶ'].option[0].value
                }
                if(this.suso_selected === ''){
                    this.suso_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][style_name]['裾形状を選ぶ↓ヨコ使いレース生地のみ'].option[0].value
                }
                if(this.open_method_selected === ''){
                    this.open_method_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][style_name]['開閉方法を選ぶ'].option[0].value
                }
            },
            style_selected2_name : function(value){
                if(this.hida_selected === ''){
                    this.hida_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.step2_data.style_selected2_name]['ヒダ倍率・ヒダスタイルを選ぶ'].option[0].value
                }
                if(this.suso_selected === ''){
                    this.suso_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.step2_data.style_selected2_name]['裾形状を選ぶ↓ヨコ使いレース生地のみ'].option[0].value
                }
                if(this.open_method_selected === ''){
                    this.open_method_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.step2_data.style_selected2_name]['開閉方法を選ぶ'].option[0].value
                }
                if(
                    this.trim_selected === '' &&
                    this.$store.state.step2_data.style_selected2_id &&
                    this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2==='トリムスタイル' ||
                    this.$store.state.step2_data.style_selected2_name === 'スカラップトリム センターウェーブ' ||
                    this.$store.state.step2_data.style_selected2_name === 'スカラップトリム ウェーブ' ||
                    this.$store.state.step2_data.style_selected2_name === 'スカラップトリム アーチ' ||
                    this.$store.state.step2_data.style_selected2_name === 'スカラップトリム M'
                ){
                    this.trim_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.step2_data.style_selected2_name]['フリンジ品番・トリム品番を選ぶ'].option[0].value
                }
            }

        },
        computed: {
            options:{
                get:function(){
                    if(this.$store.state.step2_data.style_selected2_id !==''){
                        return this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].name]['ヒダ倍率・ヒダスタイルを選ぶ'].option
                    }else if(this.$store.state.step2_data.style_selected1_id !==''){
                        return this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].name]['ヒダ倍率・ヒダスタイルを選ぶ'].option
                    }else{
                        return false
                    }
                }
            },
            open_options:{
                get:function(){
                    if(this.$store.state.step2_data.style_selected2_id !==''){
                        return this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].name]['開閉方法を選ぶ'].option
                    }
                    else if(this.$store.state.step2_data.style_selected1_id !==''){
                        return this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].name]['開閉方法を選ぶ'].option
                    }
                    else{
                        return false
                    }
                }
            },
            suso_options:{
                get:function(){
                    if(this.$store.state.step2_data.style_selected2_id !==''){
                        return this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].name]['裾形状を選ぶ↓ヨコ使いレース生地のみ'].option
                    }
                    else if(this.$store.state.step2_data.style_selected1_id !==''){
                        return this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].name]['裾形状を選ぶ↓ヨコ使いレース生地のみ'].option
                    }
                    else{
                        return false
                    }
                }
            },
            eba_options:{
                get:function(){
                    return {'裾刺繍':'裾刺繍'}
                }
            },
            hida_selected: {
                get: function () {
                    return this.$store.state.step3_data.hida
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'hida', value:value})
                }
            },
            suso_selected: {
                get: function () {
                    return this.$store.state.step3_data.suso
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'suso', value:value})
                }
            },
            trim_selected: {
                get: function () {
                    return this.$store.state.step3_data.trim
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'trim', value:value})
                }
            },
            open_method_selected: {
                get: function () {
                    return this.$store.state.step3_data.open
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'open', value:value})
                }
            },
            group2: {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    }else{
                        return ''
                    }

                },
            },
            style_selected1_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected1_name
                },
            },
            style_selected2_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_name
                },
            }
        },
    }
</script>

<style scoped>
    .hidden_select{
        display: none;
    }
</style>